import { FunctionComponent } from "react";
import {
  Table,
  TableHeaderColumn,
  SearchInput,
} from "@kanda-libs/ks-component-ts";
import type { Company, Credit, Job } from "@kanda-libs/ks-frontend-services";
import { DEFAULT_COLUMN } from "components/job/JobTable/constants";
import useJobTableProps from "components/job/JobTable/useJobTableProps";
import JobListPageActions from "components/job/JobsListPage/JobListPageActions";
import InfoBanner from "components/shared/InfoBanner";
import { FuseHit } from "@kanda-libs/ks-design-library";

export interface JobTableProps {
  showHeader?: boolean;
  jobs?: Job[];
  company?: Company;
  companies?: Company[];
  credits?: Credit[];
  solar?: boolean;
  satNoteSigned?: boolean;
  pendingPayout?: boolean;
  isLoading?: boolean;
  hits: FuseHit<Job>[];
  query: string;
  setQuery: (query: string) => void;
}

const JobTable: FunctionComponent<JobTableProps> = function ({
  showHeader = true,
  solar = false,
  satNoteSigned = false,
  pendingPayout = false,
  isLoading = false,
  hits,
  query,
  setQuery,
}) {
  const { unpaginatedData, ...tableProps } = useJobTableProps(
    solar,
    satNoteSigned,
    pendingPayout,
    hits,
    query,
    isLoading,
    showHeader
  );

  return (
    <>
      {showHeader && (
        <InfoBanner
          title="Jobs"
          nameContent={<JobListPageActions data={unpaginatedData} />}
          search={
            <SearchInput
              placeholder="Search jobs"
              query={query}
              onSearch={setQuery}
            />
          }
        />
      )}
      <Table
        {...tableProps}
        defaultColumn={DEFAULT_COLUMN as TableHeaderColumn}
        hoverPopover={null}
      />
    </>
  );
};

export default JobTable;
